'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.SUPPORTED_WALLETS = exports.LEAP_WALLET = exports.KEPLR_WALLET = exports.FIN_WALLET = exports.COMPASS_WALLET = void 0;
var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var FIN_WALLET = (exports.FIN_WALLET = {
	getAccounts: (function () {
		var _getAccounts = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee(chainId) {
				var _window;
				var offlineSigner;
				return _regenerator['default'].wrap(function _callee$(_context) {
					while (1)
						switch ((_context.prev = _context.next)) {
							case 0:
								_context.next = 2;
								return (_window = window) === null || _window === void 0 || (_window = _window['fin']) === null || _window === void 0
									? void 0
									: _window.getOfflineSignerAuto(chainId);
							case 2:
								offlineSigner = _context.sent;
								return _context.abrupt('return', (offlineSigner === null || offlineSigner === void 0 ? void 0 : offlineSigner.getAccounts()) || []);
							case 4:
							case 'end':
								return _context.stop();
						}
				}, _callee);
			})
		);
		function getAccounts(_x) {
			return _getAccounts.apply(this, arguments);
		}
		return getAccounts;
	})(),
	connect: (function () {
		var _connect = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee2(chainId) {
				var _window2;
				return _regenerator['default'].wrap(function _callee2$(_context2) {
					while (1)
						switch ((_context2.prev = _context2.next)) {
							case 0:
								_context2.next = 2;
								return (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2['fin']) === null || _window2 === void 0
									? void 0
									: _window2.enable(chainId);
							case 2:
								return _context2.abrupt('return', _context2.sent);
							case 3:
							case 'end':
								return _context2.stop();
						}
				}, _callee2);
			})
		);
		function connect(_x2) {
			return _connect.apply(this, arguments);
		}
		return connect;
	})(),
	disconnect: (function () {
		var _disconnect = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee3(chainId) {
				var _window3;
				return _regenerator['default'].wrap(function _callee3$(_context3) {
					while (1)
						switch ((_context3.prev = _context3.next)) {
							case 0:
								_context3.next = 2;
								return (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3['fin']) === null || _window3 === void 0
									? void 0
									: _window3.disconnect(chainId);
							case 2:
								return _context3.abrupt('return', _context3.sent);
							case 3:
							case 'end':
								return _context3.stop();
						}
				}, _callee3);
			})
		);
		function disconnect(_x3) {
			return _disconnect.apply(this, arguments);
		}
		return disconnect;
	})(),
	getOfflineSigner: (function () {
		var _getOfflineSigner = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee4(chainId) {
				var _window4;
				return _regenerator['default'].wrap(function _callee4$(_context4) {
					while (1)
						switch ((_context4.prev = _context4.next)) {
							case 0:
								return _context4.abrupt(
									'return',
									(_window4 = window) === null || _window4 === void 0 || (_window4 = _window4['fin']) === null || _window4 === void 0
										? void 0
										: _window4.getOfflineSignerAuto(chainId)
								);
							case 1:
							case 'end':
								return _context4.stop();
						}
				}, _callee4);
			})
		);
		function getOfflineSigner(_x4) {
			return _getOfflineSigner.apply(this, arguments);
		}
		return getOfflineSigner;
	})(),
	getOfflineSignerAmino: (function () {
		var _getOfflineSignerAmino = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee5(chainId) {
				var _window5;
				return _regenerator['default'].wrap(function _callee5$(_context5) {
					while (1)
						switch ((_context5.prev = _context5.next)) {
							case 0:
								return _context5.abrupt(
									'return',
									(_window5 = window) === null || _window5 === void 0 || (_window5 = _window5['fin']) === null || _window5 === void 0
										? void 0
										: _window5.getOfflineSignerOnlyAmino(chainId)
								);
							case 1:
							case 'end':
								return _context5.stop();
						}
				}, _callee5);
			})
		);
		function getOfflineSignerAmino(_x5) {
			return _getOfflineSignerAmino.apply(this, arguments);
		}
		return getOfflineSignerAmino;
	})(),
	signArbitrary: (function () {
		var _signArbitrary = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee6(chainId, signer, message) {
				var _window6;
				return _regenerator['default'].wrap(function _callee6$(_context6) {
					while (1)
						switch ((_context6.prev = _context6.next)) {
							case 0:
								return _context6.abrupt(
									'return',
									(_window6 = window) === null || _window6 === void 0 || (_window6 = _window6['fin']) === null || _window6 === void 0
										? void 0
										: _window6.signArbitrary(chainId, signer, message)
								);
							case 1:
							case 'end':
								return _context6.stop();
						}
				}, _callee6);
			})
		);
		function signArbitrary(_x6, _x7, _x8) {
			return _signArbitrary.apply(this, arguments);
		}
		return signArbitrary;
	})(),
	verifyArbitrary: (function () {
		var _verifyArbitrary = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee7(chainId, signingAddress, data, signature) {
				var _window7;
				return _regenerator['default'].wrap(function _callee7$(_context7) {
					while (1)
						switch ((_context7.prev = _context7.next)) {
							case 0:
								return _context7.abrupt(
									'return',
									(_window7 = window) === null || _window7 === void 0 || (_window7 = _window7['fin']) === null || _window7 === void 0
										? void 0
										: _window7.verifyArbitrary(chainId, signingAddress, data, signature)
								);
							case 1:
							case 'end':
								return _context7.stop();
						}
				}, _callee7);
			})
		);
		function verifyArbitrary(_x9, _x10, _x11, _x12) {
			return _verifyArbitrary.apply(this, arguments);
		}
		return verifyArbitrary;
	})(),
	walletInfo: {
		windowKey: 'fin',
		name: 'Fin',
		website: 'https://finwallet.com',
		icon: 'https://sei-js-assets.s3.us-west-2.amazonaws.com/fin.png'
	},
	isMobileSupported: false
});
var COMPASS_WALLET = (exports.COMPASS_WALLET = {
	getAccounts: (function () {
		var _getAccounts2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee8(chainId) {
				var _window8;
				var offlineSigner;
				return _regenerator['default'].wrap(function _callee8$(_context8) {
					while (1)
						switch ((_context8.prev = _context8.next)) {
							case 0:
								_context8.next = 2;
								return (_window8 = window) === null || _window8 === void 0 || (_window8 = _window8['compass']) === null || _window8 === void 0
									? void 0
									: _window8.getOfflineSignerAuto(chainId);
							case 2:
								offlineSigner = _context8.sent;
								return _context8.abrupt('return', (offlineSigner === null || offlineSigner === void 0 ? void 0 : offlineSigner.getAccounts()) || []);
							case 4:
							case 'end':
								return _context8.stop();
						}
				}, _callee8);
			})
		);
		function getAccounts(_x13) {
			return _getAccounts2.apply(this, arguments);
		}
		return getAccounts;
	})(),
	connect: (function () {
		var _connect2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee9(chainId) {
				var _window9;
				return _regenerator['default'].wrap(function _callee9$(_context9) {
					while (1)
						switch ((_context9.prev = _context9.next)) {
							case 0:
								_context9.next = 2;
								return (_window9 = window) === null || _window9 === void 0 || (_window9 = _window9['compass']) === null || _window9 === void 0
									? void 0
									: _window9.enable(chainId);
							case 2:
								return _context9.abrupt('return', _context9.sent);
							case 3:
							case 'end':
								return _context9.stop();
						}
				}, _callee9);
			})
		);
		function connect(_x14) {
			return _connect2.apply(this, arguments);
		}
		return connect;
	})(),
	disconnect: (function () {
		var _disconnect2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee10(chainId) {
				var _window10;
				return _regenerator['default'].wrap(function _callee10$(_context10) {
					while (1)
						switch ((_context10.prev = _context10.next)) {
							case 0:
								_context10.next = 2;
								return (_window10 = window) === null || _window10 === void 0 || (_window10 = _window10['compass']) === null || _window10 === void 0
									? void 0
									: _window10.disconnect(chainId);
							case 2:
								return _context10.abrupt('return', _context10.sent);
							case 3:
							case 'end':
								return _context10.stop();
						}
				}, _callee10);
			})
		);
		function disconnect(_x15) {
			return _disconnect2.apply(this, arguments);
		}
		return disconnect;
	})(),
	getOfflineSigner: (function () {
		var _getOfflineSigner2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee11(chainId) {
				var _window11;
				return _regenerator['default'].wrap(function _callee11$(_context11) {
					while (1)
						switch ((_context11.prev = _context11.next)) {
							case 0:
								return _context11.abrupt(
									'return',
									(_window11 = window) === null || _window11 === void 0 || (_window11 = _window11['compass']) === null || _window11 === void 0
										? void 0
										: _window11.getOfflineSignerAuto(chainId)
								);
							case 1:
							case 'end':
								return _context11.stop();
						}
				}, _callee11);
			})
		);
		function getOfflineSigner(_x16) {
			return _getOfflineSigner2.apply(this, arguments);
		}
		return getOfflineSigner;
	})(),
	getOfflineSignerAmino: (function () {
		var _getOfflineSignerAmino2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee12(chainId) {
				var _window12;
				return _regenerator['default'].wrap(function _callee12$(_context12) {
					while (1)
						switch ((_context12.prev = _context12.next)) {
							case 0:
								return _context12.abrupt(
									'return',
									(_window12 = window) === null || _window12 === void 0 || (_window12 = _window12['compass']) === null || _window12 === void 0
										? void 0
										: _window12.getOfflineSignerOnlyAmino(chainId)
								);
							case 1:
							case 'end':
								return _context12.stop();
						}
				}, _callee12);
			})
		);
		function getOfflineSignerAmino(_x17) {
			return _getOfflineSignerAmino2.apply(this, arguments);
		}
		return getOfflineSignerAmino;
	})(),
	signArbitrary: (function () {
		var _signArbitrary2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee13(chainId, signer, message) {
				var _window13;
				return _regenerator['default'].wrap(function _callee13$(_context13) {
					while (1)
						switch ((_context13.prev = _context13.next)) {
							case 0:
								return _context13.abrupt(
									'return',
									(_window13 = window) === null || _window13 === void 0 || (_window13 = _window13['compass']) === null || _window13 === void 0
										? void 0
										: _window13.signArbitrary(chainId, signer, message)
								);
							case 1:
							case 'end':
								return _context13.stop();
						}
				}, _callee13);
			})
		);
		function signArbitrary(_x18, _x19, _x20) {
			return _signArbitrary2.apply(this, arguments);
		}
		return signArbitrary;
	})(),
	verifyArbitrary: (function () {
		var _verifyArbitrary2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee14(chainId, signingAddress, data, signature) {
				var _window14;
				return _regenerator['default'].wrap(function _callee14$(_context14) {
					while (1)
						switch ((_context14.prev = _context14.next)) {
							case 0:
								return _context14.abrupt(
									'return',
									(_window14 = window) === null || _window14 === void 0 || (_window14 = _window14['compass']) === null || _window14 === void 0
										? void 0
										: _window14.verifyArbitrary(chainId, signingAddress, data, signature)
								);
							case 1:
							case 'end':
								return _context14.stop();
						}
				}, _callee14);
			})
		);
		function verifyArbitrary(_x21, _x22, _x23, _x24) {
			return _verifyArbitrary2.apply(this, arguments);
		}
		return verifyArbitrary;
	})(),
	walletInfo: {
		windowKey: 'compass',
		name: 'Compass',
		website: 'https://chrome.google.com/webstore/detail/compass-wallet/anokgmphncpekkhclmingpimjmcooifb',
		icon: 'https://sei-js-assets.s3.us-west-2.amazonaws.com/compass.png'
	},
	isMobileSupported: true
});
var KEPLR_WALLET = (exports.KEPLR_WALLET = {
	getAccounts: (function () {
		var _getAccounts3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee15(chainId) {
				var _window15;
				var offlineSigner;
				return _regenerator['default'].wrap(function _callee15$(_context15) {
					while (1)
						switch ((_context15.prev = _context15.next)) {
							case 0:
								_context15.next = 2;
								return (_window15 = window) === null || _window15 === void 0 || (_window15 = _window15['keplr']) === null || _window15 === void 0
									? void 0
									: _window15.getOfflineSignerAuto(chainId);
							case 2:
								offlineSigner = _context15.sent;
								return _context15.abrupt('return', (offlineSigner === null || offlineSigner === void 0 ? void 0 : offlineSigner.getAccounts()) || []);
							case 4:
							case 'end':
								return _context15.stop();
						}
				}, _callee15);
			})
		);
		function getAccounts(_x25) {
			return _getAccounts3.apply(this, arguments);
		}
		return getAccounts;
	})(),
	connect: (function () {
		var _connect3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee16(chainId) {
				var _window16;
				return _regenerator['default'].wrap(function _callee16$(_context16) {
					while (1)
						switch ((_context16.prev = _context16.next)) {
							case 0:
								_context16.next = 2;
								return (_window16 = window) === null || _window16 === void 0 || (_window16 = _window16['keplr']) === null || _window16 === void 0
									? void 0
									: _window16.enable(chainId);
							case 2:
								return _context16.abrupt('return', _context16.sent);
							case 3:
							case 'end':
								return _context16.stop();
						}
				}, _callee16);
			})
		);
		function connect(_x26) {
			return _connect3.apply(this, arguments);
		}
		return connect;
	})(),
	disconnect: (function () {
		var _disconnect3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee17(chainId) {
				var _window17;
				return _regenerator['default'].wrap(function _callee17$(_context17) {
					while (1)
						switch ((_context17.prev = _context17.next)) {
							case 0:
								_context17.next = 2;
								return (_window17 = window) === null || _window17 === void 0 || (_window17 = _window17['keplr']) === null || _window17 === void 0
									? void 0
									: _window17.disconnect(chainId);
							case 2:
								return _context17.abrupt('return', _context17.sent);
							case 3:
							case 'end':
								return _context17.stop();
						}
				}, _callee17);
			})
		);
		function disconnect(_x27) {
			return _disconnect3.apply(this, arguments);
		}
		return disconnect;
	})(),
	getOfflineSigner: (function () {
		var _getOfflineSigner3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee18(chainId) {
				var _window18;
				return _regenerator['default'].wrap(function _callee18$(_context18) {
					while (1)
						switch ((_context18.prev = _context18.next)) {
							case 0:
								return _context18.abrupt(
									'return',
									(_window18 = window) === null || _window18 === void 0 || (_window18 = _window18['keplr']) === null || _window18 === void 0
										? void 0
										: _window18.getOfflineSignerAuto(chainId)
								);
							case 1:
							case 'end':
								return _context18.stop();
						}
				}, _callee18);
			})
		);
		function getOfflineSigner(_x28) {
			return _getOfflineSigner3.apply(this, arguments);
		}
		return getOfflineSigner;
	})(),
	getOfflineSignerAmino: (function () {
		var _getOfflineSignerAmino3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee19(chainId) {
				var _window19;
				return _regenerator['default'].wrap(function _callee19$(_context19) {
					while (1)
						switch ((_context19.prev = _context19.next)) {
							case 0:
								return _context19.abrupt(
									'return',
									(_window19 = window) === null || _window19 === void 0 || (_window19 = _window19['keplr']) === null || _window19 === void 0
										? void 0
										: _window19.getOfflineSignerOnlyAmino(chainId)
								);
							case 1:
							case 'end':
								return _context19.stop();
						}
				}, _callee19);
			})
		);
		function getOfflineSignerAmino(_x29) {
			return _getOfflineSignerAmino3.apply(this, arguments);
		}
		return getOfflineSignerAmino;
	})(),
	signArbitrary: (function () {
		var _signArbitrary3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee20(chainId, signer, message) {
				var _window20;
				return _regenerator['default'].wrap(function _callee20$(_context20) {
					while (1)
						switch ((_context20.prev = _context20.next)) {
							case 0:
								return _context20.abrupt(
									'return',
									(_window20 = window) === null || _window20 === void 0 || (_window20 = _window20['keplr']) === null || _window20 === void 0
										? void 0
										: _window20.signArbitrary(chainId, signer, message)
								);
							case 1:
							case 'end':
								return _context20.stop();
						}
				}, _callee20);
			})
		);
		function signArbitrary(_x30, _x31, _x32) {
			return _signArbitrary3.apply(this, arguments);
		}
		return signArbitrary;
	})(),
	verifyArbitrary: (function () {
		var _verifyArbitrary3 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee21(chainId, signingAddress, data, signature) {
				var _window21;
				return _regenerator['default'].wrap(function _callee21$(_context21) {
					while (1)
						switch ((_context21.prev = _context21.next)) {
							case 0:
								return _context21.abrupt(
									'return',
									(_window21 = window) === null || _window21 === void 0 || (_window21 = _window21['keplr']) === null || _window21 === void 0
										? void 0
										: _window21.verifyArbitrary(chainId, signingAddress, data, signature)
								);
							case 1:
							case 'end':
								return _context21.stop();
						}
				}, _callee21);
			})
		);
		function verifyArbitrary(_x33, _x34, _x35, _x36) {
			return _verifyArbitrary3.apply(this, arguments);
		}
		return verifyArbitrary;
	})(),
	suggestChain: (function () {
		var _suggestChain = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee22(config) {
				var _window22;
				return _regenerator['default'].wrap(function _callee22$(_context22) {
					while (1)
						switch ((_context22.prev = _context22.next)) {
							case 0:
								return _context22.abrupt(
									'return',
									(_window22 = window) === null || _window22 === void 0 || (_window22 = _window22['keplr']) === null || _window22 === void 0
										? void 0
										: _window22.experimentalSuggestChain(config)
								);
							case 1:
							case 'end':
								return _context22.stop();
						}
				}, _callee22);
			})
		);
		function suggestChain(_x37) {
			return _suggestChain.apply(this, arguments);
		}
		return suggestChain;
	})(),
	walletInfo: {
		windowKey: 'keplr',
		name: 'Keplr',
		website: 'https://www.keplr.app/download',
		icon: 'https://sei-js-assets.s3.us-west-2.amazonaws.com/keplr.png'
	},
	isMobileSupported: false
});
var LEAP_WALLET = (exports.LEAP_WALLET = {
	getAccounts: (function () {
		var _getAccounts4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee23(chainId) {
				var _window23;
				var offlineSigner;
				return _regenerator['default'].wrap(function _callee23$(_context23) {
					while (1)
						switch ((_context23.prev = _context23.next)) {
							case 0:
								_context23.next = 2;
								return (_window23 = window) === null || _window23 === void 0 || (_window23 = _window23['leap']) === null || _window23 === void 0
									? void 0
									: _window23.getOfflineSignerAuto(chainId);
							case 2:
								offlineSigner = _context23.sent;
								return _context23.abrupt('return', (offlineSigner === null || offlineSigner === void 0 ? void 0 : offlineSigner.getAccounts()) || []);
							case 4:
							case 'end':
								return _context23.stop();
						}
				}, _callee23);
			})
		);
		function getAccounts(_x38) {
			return _getAccounts4.apply(this, arguments);
		}
		return getAccounts;
	})(),
	connect: (function () {
		var _connect4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee24(chainId) {
				var _window24;
				return _regenerator['default'].wrap(function _callee24$(_context24) {
					while (1)
						switch ((_context24.prev = _context24.next)) {
							case 0:
								_context24.next = 2;
								return (_window24 = window) === null || _window24 === void 0 || (_window24 = _window24['leap']) === null || _window24 === void 0
									? void 0
									: _window24.enable(chainId);
							case 2:
								return _context24.abrupt('return', _context24.sent);
							case 3:
							case 'end':
								return _context24.stop();
						}
				}, _callee24);
			})
		);
		function connect(_x39) {
			return _connect4.apply(this, arguments);
		}
		return connect;
	})(),
	disconnect: (function () {
		var _disconnect4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee25(chainId) {
				var _window25;
				return _regenerator['default'].wrap(function _callee25$(_context25) {
					while (1)
						switch ((_context25.prev = _context25.next)) {
							case 0:
								_context25.next = 2;
								return (_window25 = window) === null || _window25 === void 0 || (_window25 = _window25['leap']) === null || _window25 === void 0
									? void 0
									: _window25.disconnect(chainId);
							case 2:
								return _context25.abrupt('return', _context25.sent);
							case 3:
							case 'end':
								return _context25.stop();
						}
				}, _callee25);
			})
		);
		function disconnect(_x40) {
			return _disconnect4.apply(this, arguments);
		}
		return disconnect;
	})(),
	getOfflineSigner: (function () {
		var _getOfflineSigner4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee26(chainId) {
				var _window26;
				return _regenerator['default'].wrap(function _callee26$(_context26) {
					while (1)
						switch ((_context26.prev = _context26.next)) {
							case 0:
								return _context26.abrupt(
									'return',
									(_window26 = window) === null || _window26 === void 0 || (_window26 = _window26['leap']) === null || _window26 === void 0
										? void 0
										: _window26.getOfflineSignerAuto(chainId)
								);
							case 1:
							case 'end':
								return _context26.stop();
						}
				}, _callee26);
			})
		);
		function getOfflineSigner(_x41) {
			return _getOfflineSigner4.apply(this, arguments);
		}
		return getOfflineSigner;
	})(),
	getOfflineSignerAmino: (function () {
		var _getOfflineSignerAmino4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee27(chainId) {
				var _window27;
				return _regenerator['default'].wrap(function _callee27$(_context27) {
					while (1)
						switch ((_context27.prev = _context27.next)) {
							case 0:
								return _context27.abrupt(
									'return',
									(_window27 = window) === null || _window27 === void 0 || (_window27 = _window27['leap']) === null || _window27 === void 0
										? void 0
										: _window27.getOfflineSignerOnlyAmino(chainId)
								);
							case 1:
							case 'end':
								return _context27.stop();
						}
				}, _callee27);
			})
		);
		function getOfflineSignerAmino(_x42) {
			return _getOfflineSignerAmino4.apply(this, arguments);
		}
		return getOfflineSignerAmino;
	})(),
	signArbitrary: (function () {
		var _signArbitrary4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee28(chainId, signer, message) {
				var _window28;
				return _regenerator['default'].wrap(function _callee28$(_context28) {
					while (1)
						switch ((_context28.prev = _context28.next)) {
							case 0:
								return _context28.abrupt(
									'return',
									(_window28 = window) === null || _window28 === void 0 || (_window28 = _window28['leap']) === null || _window28 === void 0
										? void 0
										: _window28.signArbitrary(chainId, signer, message)
								);
							case 1:
							case 'end':
								return _context28.stop();
						}
				}, _callee28);
			})
		);
		function signArbitrary(_x43, _x44, _x45) {
			return _signArbitrary4.apply(this, arguments);
		}
		return signArbitrary;
	})(),
	verifyArbitrary: (function () {
		var _verifyArbitrary4 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee29(chainId, signingAddress, data, signature) {
				var _window29;
				return _regenerator['default'].wrap(function _callee29$(_context29) {
					while (1)
						switch ((_context29.prev = _context29.next)) {
							case 0:
								return _context29.abrupt(
									'return',
									(_window29 = window) === null || _window29 === void 0 || (_window29 = _window29['leap']) === null || _window29 === void 0
										? void 0
										: _window29.verifyArbitrary(chainId, signingAddress, data, signature)
								);
							case 1:
							case 'end':
								return _context29.stop();
						}
				}, _callee29);
			})
		);
		function verifyArbitrary(_x46, _x47, _x48, _x49) {
			return _verifyArbitrary4.apply(this, arguments);
		}
		return verifyArbitrary;
	})(),
	suggestChain: (function () {
		var _suggestChain2 = (0, _asyncToGenerator2['default'])(
			/*#__PURE__*/ _regenerator['default'].mark(function _callee30(config) {
				var _window30;
				return _regenerator['default'].wrap(function _callee30$(_context30) {
					while (1)
						switch ((_context30.prev = _context30.next)) {
							case 0:
								return _context30.abrupt(
									'return',
									(_window30 = window) === null || _window30 === void 0 || (_window30 = _window30['leap']) === null || _window30 === void 0
										? void 0
										: _window30.experimentalSuggestChain(config)
								);
							case 1:
							case 'end':
								return _context30.stop();
						}
				}, _callee30);
			})
		);
		function suggestChain(_x50) {
			return _suggestChain2.apply(this, arguments);
		}
		return suggestChain;
	})(),
	walletInfo: {
		windowKey: 'leap',
		name: 'Leap',
		website: 'https://www.leapwallet.io/download',
		icon: 'https://sei-js-assets.s3.us-west-2.amazonaws.com/leap.png'
	},
	isMobileSupported: true
});
var SUPPORTED_WALLETS = (exports.SUPPORTED_WALLETS = [COMPASS_WALLET, FIN_WALLET, LEAP_WALLET, KEPLR_WALLET]);
//# sourceMappingURL=config.js.map
